function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmileGrinSolid = function SvgSmileGrinSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M412 54c-7.72 0-14 6.28-14 14s6.28 14 14 14 14-6.28 14-14-6.28-14-14-14m-5 8c1.093 0 2 .907 2 2s-.907 2-2 2-2-.907-2-2 .907-2 2-2m10 0c1.093 0 2 .907 2 2s-.907 2-2 2-2-.907-2-2 .907-2 2-2m-9.959 7h9.918a1 1 0 0 1 1 1c0 3.28-2.68 5.959-5.959 5.959-3.28 0-5.959-2.68-5.959-5.959a1 1 0 0 1 1-1",
    color: "#000",
    style: {
      InkscapeStroke: "none"
    },
    transform: "translate(-396 -52)"
  }));
};
export default SvgSmileGrinSolid;